//------------------------------------------------------------------------------
// 線路選択入力
//------------------------------------------------------------------------------
import PropTypes from 'prop-types';
import React from 'react';
import { Field } from 'redux-form';
import { renderAutocomplete } from '@/components/atoms/CustomPart';
import backend from '@/common/backend';

/*
 * 線路選択入力コンポーネント (フォーム入力項目)
 */
function LineSelectField({
  name, label, areaCode,
  onChange, ...otherProps
}) {

  // 線路リスト
  const [ lineList, setLineList ] = React.useState([]);

  // 線路リスト取得
  React.useEffect(() => {
    const updateLineList = async () => {
      const newList = await loadLineList(areaCode);
      setLineList(newList);
    };
    updateLineList();
  }, [areaCode]);

  // 描画
  return (
    <Field
      name={name}
      label={label || '冠称'}
      component={renderAutocomplete}
      options={lineList}
      onChange={onChange}
      fullWidth
      size="small"
      variant="standard"
      {...otherProps}
    />
  );
}

// プロパティ
LineSelectField.propTypes = {
  name:       PropTypes.string.isRequired,    // フォーム項目名
  label:      PropTypes.string,               // 項目表示ラベル
  areaCode:   PropTypes.string,               // 上位地区コード
  onChange:   PropTypes.func,                 // 変更ハンドラー
  otherProps: PropTypes.object,               // その他プロパティ
};

// 線路リスト取得
async function loadLineList(areaCode) {
  if (!areaCode) {
    return [];
  }

  // 線路リスト取得
  const apiPath = '/master/lines/' + areaCode;
  const res = await backend.get(apiPath);

  // 線路リスト作成 - 線路コード + 名称
  return res
      .parseBodyAsArray()
      .map((line) => ({
        value: line.lineCode,
        label: line.lineCode + ' ' + line.lineName,  
      }));
}

// デフォルトエクスポート
export default React.memo(LineSelectField);
